import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-75 d-flex mx-auto" }
const _hoisted_2 = {
  style: {"font-size":"12px"},
  class: "w-100 d-flex justify-space-between"
}
const _hoisted_3 = { class: "dp-wrapper w-100" }
const _hoisted_4 = { class: "dp-label" }
const _hoisted_5 = ["value", "onFocus", "onBlur", "onInput"]
const _hoisted_6 = ["onClick"]

import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { ja } from 'date-fns/locale';
import i18n from '@/lang/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue', 'search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VueDatePicker), {
        locale: _unref(ja),
        "enable-time-picker": false,
        class: "w-75 m-1",
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        teleport: "body",
        "z-index": 12000,
        formats: { input: 'yyyy-MM-dd' },
        range: {
          maxRange: 31
        },
        "auto-apply": "",
        "multi-calendars": ""
      }, {
        "dp-input": _withCtx(({ value, onInput, onFocus, onBlur }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.dateRange')), 1),
            _createElementVNode("input", {
              class: "dp-input",
              value: value,
              readonly: "",
              onFocus: onFocus,
              onBlur: onBlur,
              onInput: onInput
            }, null, 40, _hoisted_5)
          ])
        ]),
        "clear-icon": _withCtx(({ clear }) => [
          _createElementVNode("div", { onClick: clear }, null, 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["locale", "modelValue"])
    ])
  ]))
}
}

})